/*
 * assets/cart-page.js
 * ------------------------------------------------------------------
 * Progressive enhancement for sections/cart.liquid:
 *  - Quantity stepper (+/-) and direct input changes update the line
 *    item via Shopify's real AJAX Cart API (POST to
 *    routes.cart_change_url + '.js', never fakes cart state).
 *  - "Remove" (a plain <a href="{{ item.url_to_remove }}">, so it
 *    still works with JS disabled) is intercepted and turned into the
 *    same AJAX quantity-to-0 call instead of a full navigation.
 *  - The request asks for BOTH this section's own re-rendered HTML
 *    and (when a cart drawer is present on the page, via
 *    window.UnnamedCart from assets/header-interactions.js) the
 *    drawer/header's cart-count section — single source of truth, no
 *    separate cart total calculation duplicated here. Swapping this
 *    section's own HTML back in also naturally clears the page the
 *    moment the cart becomes empty (Liquid's own empty-state branch).
 *  - If a request fails, or JS never loads, the quantity fields and
 *    the (JS-disabled-only) "Update cart" submit button fall back to
 *    the plain native form the original skeleton theme used — nothing
 *    breaks with JS off.
 * ------------------------------------------------------------------
 */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);

  function initAll() {
    document.querySelectorAll("[data-cart-page]").forEach(initCartPage);
  }

  function initCartPage(root) {
    if (root.dataset.cartPageInit === "true") return;
    root.dataset.cartPageInit = "true";

    var sectionId = root.getAttribute("data-section-id");
    var changeUrl = root.getAttribute("data-cart-change-url") || "/cart/change.js";

    function drawerSectionId() {
      var drawer = document.getElementById("CartDrawer");
      return drawer ? drawer.getAttribute("data-section-id") : null;
    }

    function updateLine(key, quantity) {
      var sections = [sectionId];
      var drawerId = drawerSectionId();
      if (drawerId && drawerId !== sectionId) sections.push(drawerId);

      var body = { id: key, quantity: quantity, sections: sections.join(",") };

      fetch(changeUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (!data || !data.sections) return;

          if (sectionId && data.sections[sectionId]) {
            replaceSection(data.sections[sectionId]);
          }

          if (window.UnnamedCart && drawerId && data.sections[drawerId]) {
            window.UnnamedCart.refresh(data.sections[drawerId]);
          }
        })
        .catch(function () {
          /* Never fake cart state — if the request fails, fall back
             to a real navigation so the customer sees the true cart
             rather than a stale quantity. */
          window.location.href = "/cart";
        });
    }

    function replaceSection(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var newRoot = doc.querySelector('[data-section-id="' + sectionId + '"]');
      if (!newRoot || !root.parentNode) return;
      root.parentNode.replaceChild(newRoot, root);
      newRoot.dataset.cartPageInit = "false";
      initCartPage(newRoot);
    }

    root.addEventListener("click", function (e) {
      var decrease = e.target.closest("[data-cart-page-qty-decrease]");
      var increase = e.target.closest("[data-cart-page-qty-increase]");
      var remove = e.target.closest("[data-cart-page-remove]");
      if (!decrease && !increase && !remove) return;

      var item = e.target.closest("[data-cart-page-item]");
      if (!item) return;
      var key = item.getAttribute("data-key");

      if (remove) {
        e.preventDefault();
        updateLine(key, 0);
        return;
      }

      var input = item.querySelector("[data-cart-page-qty-input]");
      var current = input ? parseInt(input.value, 10) || 0 : 0;

      if (decrease) {
        updateLine(key, Math.max(0, current - 1));
      } else if (increase) {
        updateLine(key, current + 1);
      }
    });

    root.addEventListener("change", function (e) {
      if (!e.target.matches("[data-cart-page-qty-input]")) return;
      var item = e.target.closest("[data-cart-page-item]");
      if (!item) return;
      var key = item.getAttribute("data-key");
      var quantity = Math.max(0, parseInt(e.target.value, 10) || 0);
      updateLine(key, quantity);
    });

    var form = root.querySelector("[data-cart-page-form]");
    if (form) {
      /* JS is working, so the AJAX handlers above already cover every
         interaction — the plain <noscript> submit button is the only
         JS-disabled fallback and needs no extra wiring here. Prevent
         the (now redundant) Enter-key native submit on a quantity
         input from causing a full page reload for a change already
         handled above. */
      form.addEventListener("submit", function (e) {
        e.preventDefault();
      });
    }
  }
})();
